<template>
  <h-frame type="right">
    <div class="threeSolidRight">
      <div class="itemDetail">
        <x-title> 车流量趋势 </x-title>
        <housingRightOne></housingRightOne>
      </div>
      <div class="itemDetail">
        <x-title>
          <div class="titleWidth">昼伏夜出</div>
        </x-title>
        <housingRightTwo></housingRightTwo>
      </div>
      <div class="itemDetail">
        <x-title>
          <div class="titleWidth">设备抓拍</div>
        </x-title>
        <housingRightThree></housingRightThree>
      </div>
    </div>
  </h-frame>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";
import {
  securitylist,
  strengthlist,
  equipmentlist,
} from "@/api/threeSolid/threeSolidHome.js";
import housingRightOne from "./housingRightOne";
import housingRightTwo from "./housingRightTwo";
import housingRightThree from "./housingRightThree";
export default defineComponent({
  name: "",
  components: { housingRightOne, housingRightTwo, housingRightThree },
  props: {},
  setup(props) {
    const data = reactive({
      eventList: [
        {
          name: "噪音扰民",
          type: "矛盾纠纷",
          addrens: "丰盛园社区",
          people: "张三",
        },
        {
          name: "噪音扰民",
          type: "矛盾纠纷",
          addrens: "丰盛园社区",
          people: "张三",
        },
      ],
      moreFalse: false,
      securitylists: [],
      strengthlist: [],
      equipmentlists: [],
    });
    const refData = toRefs(data);
    const moreClick = () => {
      data.moreFalse = !data.moreFalse;
    };
    // 实有安防
    const securitylistquery = async () => {
      const res = await securitylist();
      console.log("1111111~ securitylistquery ~ res", res);
      data.securitylists = res.data;
    };
    // 实有力量
    const strengthlistquery = async () => {
      const res = await strengthlist();
      console.log("2222222 ~ strengthlistquery ~ res", res);
      data.strengthlists = res.data;
    };
    // 实有装备
    const equipmentlistquery = async () => {
      const res = await equipmentlist();
      console.log("33333~ equipmentlistquery ~ res", res);
      data.equipmentlists = res.data;
    };
    securitylistquery();
    strengthlistquery();
    equipmentlistquery();

    return {
      ...refData,
      moreClick,
    };
  },
});
</script>
<style lang="scss" scoped>
.threeSolidRight {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  padding-top: 10px;
  color: #fff;
  overflow: auto;
  .itemDetail {
    height: 33%;
  }
  .titleWidth {
    width: 100%;
  }
  .titleMore {
    float: right;
    cursor: pointer;
    margin-right: 15px;
  }
  .titleYellow {
    width: 100%;
    text-align: center;
    color: #f3ce61;
    line-height: 40px;
  }
  .rightItem {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    font-size: 14px;
    .leftpeople {
      width: 100%;
      height: 100px;
      display: flex;
      flex-direction: column;
      // margin-bottom: 20px;
      .yellowColor {
        width: 100%;
        text-align: center;
        color: #f3ce61;
        line-height: 40px;
      }
      .peopleecharts {
        display: flex;
        flex-direction: column;

        .oneBox {
          display: flex;
          justify-content: space-between;
          line-height: 30px;
          .bluecolore {
            color: #91c8ff;
          }
        }
        .oneBluebg {
          width: 100%;
          height: 30px;
          background: rgba(0, 143, 187, 1);
          border-radius: 4px;
          position: relative;

          .bluecount {
            width: 200px;
            text-align: center;
            height: 100%;
            position: absolute;
            border-radius: 4px;
            box-shadow: 0 0 10px 3px #00c9fa inset;
            background: #00a8ec;
            z-index: 2;
            line-height: 30px;
          }
          .noBlue {
            position: absolute;
            right: 20px;
            line-height: 30px;
          }
        }
      }
    }
    .rightspecial {
      flex-wrap: wrap;
      display: flex;
      justify-content: space-around;
      padding: 20px 36px;
    }
    .itemList {
      width: 81px;
      height: 72px;
      display: flex;
      flex-direction: column;
      background-image: url("~@/assets/images/home/yujing.png");
      text-align: center;
      margin-bottom: 24px;
      .itenSize {
        margin-top: 18px;
        margin-bottom: 35px;
      }
    }
  }
  .event {
    width: 100%;
    display: flex;
    flex-direction: column;
    // margin-bottom: 15px;
    .eventTop {
      display: flex;
      margin: 15px 0;
      justify-content: space-around;
      .topItem {
        display: flex;
      }
      .topLeft {
        width: 58px;
        height: 57px;
        margin-right: 10px;
        text-align: center;
        line-height: 57px;
        background-image: url("~@/assets/images/home/yuan.png");
        background-size: cover;
      }
      .topRight {
        display: flex;
        flex-direction: column;
        .sizeNum {
          font-size: 20px;
          margin-bottom: 5px;
        }
      }
    }
  }
  .echarts {
    width: 100%;
    height: 180px;
  }

  .blueColor {
    color: #73f1f3;
  }
  .moreSelect {
    position: absolute;
    bottom: 24px;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    border-radius: 4px;
    line-height: 28px;
    cursor: pointer;
  }
  .downBtn {
    padding: 3px 5px;
    background: rgba(0, 0, 0, 0.5);
    // border-radius: 5px;
    position: absolute;
    width: 100%;
    text-align: center;
    cursor: pointer;
  }
}
</style>
